import React from "react";
import Text from "../../uikit/text/Text";
import Box from "../../uikit/box/Box";
import RatingDot from "./RatingDot";

/**
 * Dot + score + label, laid out so a column of these lines up.
 *
 * The label never wraps and the score always occupies a slot — an em dash when
 * there is no rating yet. Both exist so that rows sitting above one another keep
 * the same height and the same dot position; letting either collapse is what
 * made a list of attendee cards look randomly staggered.
 */
export default ({ rating, showRatingText = true, label, ...rest }) => {
  // Reject "no rating" BEFORE coercing: Number(null) and Number('') are 0, so a
  // meeting with no AI score and an attendee nobody rated both read as a
  // confident 0 instead of the em dash.
  const hasValue =
    rating !== null && rating !== undefined && rating !== '' && Number.isFinite(Number(rating));
  const value = hasValue ? Number(rating) : null;

  return (
    <Box display="flex" alignItems="center" {...rest}>
      <RatingDot rating={value} />
      {showRatingText && (
        <Text ml={2} fontSize={1} color={hasValue ? undefined : "grays.2"}>
          {hasValue ? value : "—"}
        </Text>
      )}
      {label && (
        <Text ml={2} fontSize={1} style={{ whiteSpace: "nowrap" }}>
          {label}
        </Text>
      )}
    </Box>
  );
};
